<template>
  <div class="my-register-page">
    <div class="my-container">
      <b-row class="mt-4">
        <b-col sm="12" md="12" lg="12">
          <label for></label>
          <b-list-group>
            <b-list-group-item class="d-flex justify-content-between">
              <span> {{ $t("authorizedOrganization") }}: </span>
              <span style="width: 80%; font-size: 15px">
                <b> {{ Complaint.authorizedOrganization }} </b>
              </span>
            </b-list-group-item>
          </b-list-group>
        </b-col>
      </b-row>
      <b-row class="mt-1">
        <b-col sm="12" md="6" lg="6">
          <b-list-group>
            <b-list-group-item class="d-flex justify-content-between">
              <span> {{ $t("requestDocNumber") }}: </span>
              <span>
                <b> {{ Complaint.requestDocNumber }} </b>
              </span>
            </b-list-group-item>
          </b-list-group>
        </b-col>
        <b-col sm="12" md="6" lg="6"> </b-col>
      </b-row>
      <b-row class="mt-1">
        <b-col sm="12" md="12">
          <b-list-group>
            <b-list-group-item class="d-flex justify-content-between">
              <span> {{ $t("checkDate") }}: </span>
              <span>
                <b>
                  {{ Complaint.checkStartDate }} -
                  {{ Complaint.checkEndDate }} ({{ Complaint.checkDaysNumber }}
                  {{ $t("day") }} )
                </b>
              </span>
            </b-list-group-item>
          </b-list-group>
        </b-col>
        <b-col sm="12" md="12" class="mt-1">
          <b-list-group>
            <b-list-group-item class="d-flex justify-content-between">
              <span> {{ $t("checkCoverageDate1") }}: </span>
              <span>
                <b>
                  {{ Complaint.checkCoverageStartDate }} -
                  {{ Complaint.checkCoverageEndDate }}
                </b>
              </span>
            </b-list-group-item>
          </b-list-group>
        </b-col>
      </b-row>
      <b-row class="mt-1">
        <b-col sm="12" md="6" lg="6">
          <b-list-group>
            <b-list-group-item class="d-flex justify-content-between">
              <span> {{ $t("orderedOrganization") }}: </span>
              <span>
                <b> {{ Complaint.orderedOrganization }} </b>
              </span>
            </b-list-group-item>
          </b-list-group>
        </b-col>
        <b-col sm="12" md="6" lg="6">
          <b-list-group>
            <b-list-group-item class="d-flex justify-content-between">
              <span> {{ $t("inspectionOrganization") }}: </span>
              <span>
                <b> {{ Complaint.inspectionOrganization }} </b>
              </span>
            </b-list-group-item>
          </b-list-group>
        </b-col>
      </b-row>
      <b-row class="mt-2">
        <b-col sm="12" md="6" lg="6">
          <label for>{{ $t("docDate") }}</label>
          <custom-date-picker
            v-model="Complaint.docDate"
            @keyup="docDateValue"
            format="DD.MM.YYYY"
            type="date"
            :clearable="false"
            :placeholder="$t('docdate')"
          >
          </custom-date-picker>
        </b-col>
      </b-row>

      <b-row class="mt-2">
        <b-col>
          <custom-textarea
            :disabled="Complaint.statusId == 2"
            v-model="Complaint.complaintText"
            :label="$t('complaintText')"
          >
          </custom-textarea>
        </b-col>
      </b-row>
      <b-row class="mt-2">
        <b-col>
          <custom-textarea
            :disabled="Complaint.statusId == 2"
            v-model="Complaint.suggestion"
            :label="$t('suggestion')"
          >
          </custom-textarea>
        </b-col>
      </b-row>

      <!-- Rating block: shown when complaint is already submitted (statusId === 2) -->
      <section v-if="Complaint.statusId == 2" class="rt-card mt-4">
        <div class="rt-card-head">
          <h2>
            <span class="rt-step">2</span>
            {{ $t("RatingStep2") || "Baholash" }}
          </h2>
          <span class="rt-hint">{{ $t("RatingStep2Hint") }}</span>
        </div>
        <div class="rt-card-body">
          <div v-if="rating.loaded && rating.alreadyRated" class="rt-already">
            <i class="fas fa-check-circle"></i>
            {{ $t("RatingAlreadySubmitted") || "Baholash yuborilgan" }}
          </div>

          <div class="rt-rate-block">
            <div class="rt-who">
              <div class="rt-who-icon"><i class="fas fa-clipboard-check"></i></div>
              <div>
                <div class="rt-who-lbl">
                  {{ $t("InspectionProcess") || "Tekshiruv jarayoni" }}
                </div>
                <div class="rt-who-nm">{{ Complaint.requestDocNumber }}</div>
              </div>
            </div>
            <div class="rt-stars">
              <button
                v-for="n in 5"
                :key="'i' + n"
                class="rt-star"
                :class="{ filled: n <= rating.inspectionRating }"
                :disabled="rating.alreadyRated || rating.submitting"
                @click="rating.alreadyRated || (rating.inspectionRating = n)"
              >
                <i class="fas fa-star"></i>
              </button>
              <strong class="rt-stars-val">{{ rating.inspectionRating }} / 5</strong>
            </div>
            <textarea
              v-model="rating.inspectionComment"
              class="rt-comment"
              maxlength="500"
              :disabled="rating.alreadyRated || rating.submitting"
              :placeholder="
                $t('InspectionCommentPh') ||
                  'Tekshiruv jarayoni haqida izoh (ixtiyoriy)'
              "
            ></textarea>
          </div>

          <div v-if="rating.inspectors.length" class="rt-rate-block">
            <div class="rt-who">
              <div class="rt-who-icon"><i class="fas fa-users"></i></div>
              <div>
                <div class="rt-who-lbl">
                  {{
                    $t("InspectorsInThisInspection") ||
                      "Tekshiruvda qatnashgan tekshiruvchilar"
                  }}
                </div>
                <div class="rt-who-nm">
                  {{ $t("RateAllInspectorsTogether") || "Hammasi uchun umumiy baho" }}
                </div>
              </div>
            </div>
            <ul class="rt-insp-names">
              <li v-for="(nm, idx) in rating.inspectors" :key="'ins-' + idx">
                <i class="far fa-user"></i> {{ nm }}
              </li>
            </ul>
            <div class="rt-stars">
              <button
                v-for="n in 5"
                :key="'all' + n"
                class="rt-star"
                :class="{ filled: n <= rating.inspectorsRating }"
                :disabled="rating.alreadyRated || rating.submitting"
                @click="rating.alreadyRated || (rating.inspectorsRating = n)"
              >
                <i class="fas fa-star"></i>
              </button>
              <strong class="rt-stars-val">{{ rating.inspectorsRating }} / 5</strong>
            </div>
            <textarea
              v-model="rating.inspectorsComment"
              class="rt-comment"
              maxlength="500"
              :disabled="rating.alreadyRated || rating.submitting"
              :placeholder="
                $t('InspectorCommentPh') ||
                  'Tekshiruvchilar haqida izoh (ixtiyoriy)'
              "
            ></textarea>
          </div>
        </div>

        <div v-if="rating.error" class="rt-error" style="margin: 0 22px 12px">
          <i class="fas fa-exclamation-circle"></i> {{ rating.error }}
        </div>

        <div v-if="!rating.alreadyRated" class="rt-actions">
          <button
            class="rt-btn primary"
            :disabled="!canSubmitRating || rating.submitting"
            @click="submitRating"
          >
            <i v-if="rating.submitting" class="fas fa-spinner fa-spin"></i>
            <template v-else>
              {{ $t("Submit") || "Yuborish" }}
              <i class="fas fa-arrow-right"></i>
            </template>
          </button>
        </div>
      </section>

      <b-row v-if="Complaint.statusId != 2" class="mt-5">
        <b-col align="right" sm="12" md="12" lg="12" class="text-right">
          <b-button @click="SaveData" variant="outline-success">
            <feather-icon icon="CheckIcon"></feather-icon> {{ $t("Save") }}
          </b-button>
        </b-col>
      </b-row>
    </div>
  </div>
</template>
<script>
import ComplaintService from "@/services/complaint.service";
import RequestRatingService from "@/services/requestrating.service";
import CustomDatePicker from "../../components/customDatePicker.vue";
import {
  BCard,
  BRow,
  BCol,
  BButton,
  BCardText,
  BFormInput,
  BListGroup,
  BListGroupItem,
} from "bootstrap-vue";
import CustomTextarea from "../../components/elements/customTextarea.vue";
export default {
  data() {
    return {
      GetByRequestIdLoading: false,
      Complaint: {},
      rating: {
        loaded: false,
        loading: false,
        submitting: false,
        alreadyRated: false,
        error: "",
        inspectors: [],
        inspectionRating: 0,
        inspectionComment: "",
        inspectorsRating: 0,
        inspectorsComment: "",
      },
    };
  },
  computed: {
    canSubmitRating() {
      if (this.rating.inspectionRating < 1) return false;
      if (this.rating.inspectors.length && this.rating.inspectorsRating < 1) return false;
      return true;
    },
  },
  components: {
    BCard,
    BRow,
    BCol,
    BButton,
    BCardText,
    BFormInput,
    CustomDatePicker,
    CustomTextarea,
    BListGroup,
    BListGroupItem,
  },
  created() {
    this.Refresh();
  },
  methods: {
    Refresh() {
      ComplaintService.GetByRequestId(this.$route.params.id)
        .then((res) => {
          this.Complaint = res.data;
          if (this.Complaint && this.Complaint.statusId == 2 && this.Complaint.requestDocNumber) {
            this.loadRating(this.Complaint.requestDocNumber);
          }
        })
        .catch((error) => {
          this.makeToast(error.response.data, "error");
        });
    },
    loadRating(docNumber) {
      this.rating.loading = true;
      this.rating.error = "";
      RequestRatingService.GetByDocNumber(docNumber)
        .then((res) => {
          const d = (res && res.data) || {};
          const names = Array.isArray(d.inspectorNames) ? d.inspectorNames : [];
          this.rating.inspectors = names;
          return RequestRatingService.GetList({
            search: docNumber,
            sortBy: "",
            orderType: "",
            page: 1,
            pageSize: 20,
          })
            .then((r) => {
              const rows = (r && r.data && (r.data.rows || r.data.items)) || [];
              const own = rows.filter((x) => x.docNumber === docNumber);
              if (own.length) {
                this.rating.alreadyRated = true;
                const req = own.find((x) => x.isRequest);
                const ins = own.find((x) => !x.isRequest);
                if (req) {
                  this.rating.inspectionRating = req.rating || 0;
                  this.rating.inspectionComment = req.text || "";
                }
                if (ins) {
                  this.rating.inspectorsRating = ins.rating || 0;
                  this.rating.inspectorsComment = ins.text || "";
                }
              }
            })
            .catch(() => { /* ignore — assume not rated */ });
        })
        .catch(() => { /* docNumber lookup failed — leave inspectors empty */ })
        .finally(() => {
          this.rating.loading = false;
          this.rating.loaded = true;
        });
    },
    extractRatingError(err) {
      const fallback = this.$t("RatingSubmitError") || "Baholashni yuborishda xatolik";
      const data = err && err.response && err.response.data;
      if (!data) return fallback;
      if (typeof data === "string" && data.trim()) return data;
      if (data.errors && typeof data.errors === "object") {
        const msgs = [];
        Object.values(data.errors).forEach((v) => {
          if (Array.isArray(v)) msgs.push(...v);
          else if (typeof v === "string") msgs.push(v);
        });
        if (msgs.length) return Array.from(new Set(msgs)).join("; ");
      }
      if (data.message) return data.message;
      if (data.title) return data.title;
      return fallback;
    },
    submitRating() {
      if (!this.canSubmitRating || this.rating.submitting) return;
      this.rating.submitting = true;
      this.rating.error = "";
      const docNumber = this.Complaint.requestDocNumber;
      const payloads = [
        {
          docNumber: docNumber,
          rating: this.rating.inspectionRating,
          isRequest: true,
          text: this.rating.inspectionComment || "",
        },
      ];
      if (this.rating.inspectors.length && this.rating.inspectorsRating > 0) {
        payloads.push({
          docNumber: docNumber,
          rating: this.rating.inspectorsRating,
          isRequest: false,
          text: this.rating.inspectorsComment || "",
        });
      }
      Promise.all(payloads.map((p) => RequestRatingService.Create(p)))
        .then(() => {
          this.rating.alreadyRated = true;
          this.makeToast(this.$t("RatingSubmitted"), "success");
        })
        .catch((err) => {
          this.rating.error = this.extractRatingError(err);
        })
        .finally(() => {
          this.rating.submitting = false;
        });
    },
    makeToast(message, type) {
      var a = "";
      if (message.status == 500) {
        a = message.title;
      }
      if (message.status == 400) {
        var errors = Object.values(message.errors);
        var a = errors.map((el, item) => item + 1 + "." + el).join("\n");
      } else {
        a = message;
      }
      this.$toast.open({
        message: a,
        type: type,
        duration: 5000,
        dismissible: true,
      });
    },
    docDateValue(value) {
      this.Complaint.docDate = value;
    },

    back() {
      this.$router.go(-1);
    },
    SaveData() {
      ComplaintService.Update(this.Complaint)
        .then((res) => {
          this.makeToast(this.$t("SaveSuccess"), "success");
          this.$router.push({ name: `complaint` });
        })
        .catch((error) => {
          this.makeToast(error.response.data, "error");
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.rt-card {
  background: #fff;
  border: 1px solid #e3e6ee;
  border-radius: 14px;
  overflow: hidden;
}
.rt-card-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 20px;
  border-bottom: 1px solid #eef0f5;
  gap: 12px;
  flex-wrap: wrap;
}
.rt-card-head h2 {
  font-size: 16px;
  font-weight: 800;
  margin: 0;
  display: flex;
  align-items: center;
  gap: 10px;
  color: #1c2238;
}
.rt-step {
  width: 26px;
  height: 26px;
  border-radius: 50%;
  background: #2a3b5d;
  color: #fff;
  font-size: 13px;
  font-weight: 800;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
.rt-hint {
  font-size: 12px;
  color: #6b7388;
}
.rt-card-body {
  padding: 18px 20px;
  display: flex;
  flex-direction: column;
  gap: 18px;
}
.rt-already {
  background: #d1fae5;
  color: #065f46;
  padding: 10px 14px;
  border-radius: 10px;
  font-weight: 700;
  font-size: 13px;
  display: flex;
  align-items: center;
  gap: 8px;
}
.rt-rate-block {
  padding: 14px;
  background: #f8f9fc;
  border-radius: 12px;
  border: 1px solid #eef0f5;
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.rt-who {
  display: flex;
  align-items: center;
  gap: 12px;
}
.rt-who-icon {
  width: 38px;
  height: 38px;
  border-radius: 10px;
  background: #eef2fb;
  color: #2a3b5d;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
}
.rt-who-lbl {
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.6px;
  text-transform: uppercase;
  color: #8a92a8;
}
.rt-who-nm {
  font-size: 14px;
  font-weight: 700;
  color: #1c2238;
}
.rt-insp-names {
  list-style: none;
  margin: 0;
  padding: 10px 14px;
  background: #fff;
  border-radius: 10px;
  border: 1px solid #eef0f5;
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.rt-insp-names li {
  font-size: 13px;
  color: #1c2238;
  display: flex;
  align-items: center;
  gap: 8px;
}
.rt-insp-names li i { color: #2a3b5d; font-size: 12px; }
.rt-stars {
  display: flex;
  align-items: center;
  gap: 4px;
}
.rt-star {
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px;
  color: #d9dde6;
  font-size: 22px;
  transition: color 0.15s, transform 0.1s;
}
.rt-star:hover:not(:disabled) { color: #f5b800; }
.rt-star.filled { color: #f5b800; }
.rt-star:disabled { cursor: default; opacity: 0.85; }
.rt-stars-val {
  margin-left: 8px;
  font-size: 13px;
  color: #4a526a;
  font-weight: 700;
}
.rt-comment {
  width: 100%;
  border: 1.5px solid #e3e6ee;
  border-radius: 10px;
  padding: 10px 12px;
  font-size: 13px;
  font-family: inherit;
  min-height: 70px;
  resize: vertical;
  outline: none;
  background: #fff;
  color: #1c2238;
}
.rt-comment:focus { border-color: #2a3b5d; }
.rt-comment:disabled { background: #f8f9fc; color: #4a526a; }
.rt-error {
  background: #fdecec;
  border: 1px solid #f6c0c0;
  color: #b43a3a;
  padding: 9px 12px;
  border-radius: 8px;
  font-size: 13px;
  display: flex;
  align-items: center;
  gap: 8px;
}
.rt-actions {
  padding: 14px 20px;
  border-top: 1px solid #eef0f5;
  display: flex;
  justify-content: flex-end;
}
.rt-btn {
  padding: 9px 22px;
  border-radius: 10px;
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
  border: 1.5px solid transparent;
  display: inline-flex;
  align-items: center;
  gap: 7px;
  transition: background 0.15s, opacity 0.15s;
}
.rt-btn:disabled { opacity: 0.55; cursor: not-allowed; }
.rt-btn.primary {
  background: #2a3b5d;
  color: #fff;
  border-color: #2a3b5d;
}
.rt-btn.primary:hover:not(:disabled) { background: #1f2d4a; }
</style>
